export default __webpack_public_path__ + "static/media/youdont1.f29c80e7.svg";